// src/domains/table.keys.ts —— 模板键归属（TD-823）：原型键 48（表格 / 抽屉 / 表单 / 确认框四片）+ 0107 偏差块新增 8 键（C-00 / D31）
export const KEYS = [
  'cols', 'doPrimary', 'exportCsv', 'facets', 'hasLastReq', 'hasPageNote', 'hasStats', 'lastReq', 'loading', 'nextPage', 'nextStyle', 'noLastReq',
  'onPageSize', 'onQd', 'pageNote', 'pageSize', 'pages', 'prevPage', 'prevStyle', 'primaryAction', 'primaryIcon', 'qd', 'resetQuery', 'rowCountText',
  'rows', 'rowsEmpty', 'runQuery', 'searching', 'stats', 'tableBodyStyle', 'closeDrawer', 'drawer', 'drawerOpen', 'note', 'onNote', 'stop',
  'closeForm', 'form', 'formErr', 'formOpen', 'formSaving', 'submitForm', 'closeConfirm', 'confirmLabel', 'confirmOpen', 'confirmText', 'confirmTitle', 'doConfirm',
  'canExport', 'primaryTitle', 'primaryStyle', 'secondaryAction', 'secondaryIcon', 'doSecondary', 'secondaryTitle', 'secondaryStyle',
] as const;

// 表格主体 30 键（未注册页透传）；原型 48 键（parity 比较集合）
export const GRID_KEYS = KEYS.slice(0, 30);
export const PROTO_KEYS = KEYS.slice(0, 48);
// 抽屉 / 表单 / 确认框三组（各组按原生状态独立判定来源）
export const DRAWER_KEYS = KEYS.slice(30, 36);
export const FORM_KEYS = KEYS.slice(36, 42);
export const CONFIRM_KEYS = KEYS.slice(42, 48);
// 0107 偏差块新增 8 键：原型无对应，全部页由原生给出
export const NEW_KEYS = KEYS.slice(48);
